import { Check } from "lucide-react";

import { Shell } from "./shell";

export function firstName(name: string | undefined) {
	const trimmed = (name ?? "").trim();

	if (trimmed === "") {
		return "tudo certo";
	}

	return trimmed.split(" ")[0];
}

export function WizardDone({ title, description }: { title: string; description: string }) {
	return (
		<Shell>
			<div className="fade-up max-w-xl text-center">
				<div className="mx-auto flex size-20 items-center justify-center rounded-full bg-whatsapp/15 text-whatsapp">
					<Check className="size-10" />
				</div>

				<h1 className="mt-6 font-display text-3xl break-words text-foreground sm:text-4xl">
					{title}
				</h1>

				<p className="mt-4 text-xl text-muted-foreground">{description}</p>
			</div>
		</Shell>
	);
}
